import { StoryblokComponent } from '@storyblok/react';
import React, { useEffect, useState } from 'react';

import { patchedStoryblokEditable } from 'apps/urban/utils/patchedStoryblokEditable';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { Modal } from '../Modal/Modal';
import { BannerLinkContainer, BannerLinkText } from './BannerLink.style';
import { TBannerLinkProps } from './BannerLink.types';

export const BannerLink = ({
  blok,
  blok: { linkText, linkUrl, enableModal, modalContent },
}: TBannerLinkProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleModal = () => setIsOpen(!isOpen);

  const router = useRouter();

  useEffect(() => {
    if (!enableModal) return;

    const handleRouteChange = () => {
      setIsOpen(false);
    };

    router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router.events, enableModal]);

  return (
    <>
      <BannerLinkContainer {...patchedStoryblokEditable(blok)}>
        {enableModal ? (
          <BannerLinkText onClick={toggleModal}>{linkText}</BannerLinkText>
        ) : (
          <Link href={linkUrl.cached_url} passHref>
            <BannerLinkText>{linkText}</BannerLinkText>
          </Link>
        )}
      </BannerLinkContainer>

      {enableModal && modalContent?.length > 0 && (
        <Modal isOpen={isOpen} toggleModal={toggleModal} compactModal>
          {modalContent.map((blokData) => (
            <StoryblokComponent blok={blokData} key={blokData._uid} />
          ))}
        </Modal>
      )}
    </>
  );
};
